<template lang="pug" src="./footer.pug"></template>

<script>
export default {
  data () {
    return {
      setDate: 0
    }
  },
  computed: {
    props () {
      return this.$store.state.app['footer']
    }
  },
  async created () {
    this.setDate = 2000 + (new Date().getYear() - 100)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer/footer.vue